/* CreateAction.js */

"use strict";
const Registrations = require("../../../../../RegistrationNamespaces");
const CreateOsCatalogComponent = require("./CreateOsCatalogComponent");

class CreateAction {
    constructor(logger, gameEditor, modalUserFeedback, OsImageCatalogEntity, userSession, activeView) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._catalogEntity = new OsImageCatalogEntity(userSession.activeOrganization.id);
        this._modalUserFeedback = modalUserFeedback;
        this._activeView = activeView;
        this.run = this.run.bind(this);
    }
    run() {
        return this._modalUserFeedback
            .displayCustom(new CreateOsCatalogComponent(this._logger), { dontHide: true })
            .then((result) => {
                this._modalUserFeedback.displayLoading();
                return this._createCatalog(result.trim()).catch((err) => {
                    this._logger.warn({ error: err }, "CreateAction._createCatalog() error.");
                    return this._modalUserFeedback.displayError(err);
                });
            })
            .then((result) => {
                let editorState = {
                    fqn: Registrations.OS_CATALOG_EDITOR_VIEW_DETAILS,
                    viewState: { createMode: true }
                };
                let launchOpts = {
                    id: result.id,
                    title: result.properties.name
                };
                this._modalUserFeedback.hideDisplayed();
                this._gameEditor.launchOsCatalogEditor(editorState, launchOpts);
                if (typeof this._activeView.rcataloglection === "function" && typeof this._activeView.lcatalogScrollTo === "function") {
                    this._activeView.resetSelection([result.id]);
                    this._activeView.loadAndScrollTo(result.id);
                }
            })
            .catch((err) => {
                this._modalUserFeedback.hideDisplayed();
                this._logger.warn({ error: err }, "CreateAction.run() - Either error or cancellation");
            });
    }
    _createCatalog(name) {
        // Defaults
        this._catalogEntity.name = name;
        this._catalogEntity.description = "";
        return this._catalogEntity.create();
    }
}
module.exports = CreateAction;

CreateAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.ui.userFeedback",
    "$teve.entities.OsImageCatalog",
    "$teve.userSession",
    "gameEditor.activeView"
];

CreateAction.$displayDetails = {
    type: "Action",
    name: "CreateAction",
    icon: "osmanager.add_os_catalog",
    shown: true,
    title: "Add Entry",
    order: 1
};
